@if (productPrices) {
    <div [ngClass]="{ 'py-1 border-b2': templateConfiguration?.showLinesInDetails }" class="product-price" [ngStyle]="{ color: colorStyle }">
        <formatted-price
            [price$$]="productPrices.price.value"
            [secondaryPrice$$]="productPrices.oldPrice.value"
            [terciaryPrice$$]="productPrices.originalPrice.value"
            [lastReducedPrice$$]="productPrices.lastReducedPrice.value"
            [options$$]="{
                showAlternateCurrencies: true,
                fromShopToLook: fromShopToLook,
                pricesInTwoColumns: pricesInTwoColumns
            }"
            [pricesClasses$$]="classPrices$ | async"
            [pricesStyles$$]="{
                primaryPrice: { color: templateConfiguration?.styles && templateConfiguration.styles['fontColor'] },
                secondaryPrice: { color: templateConfiguration?.styles && templateConfiguration.styles['offerPrice'] },
                cmsStyles: priceStyles$ | async
            }"
        >
            <!-- Percent Price only enabled triple -->
            @if (productPrices.percent.placePrice) {
                <label primaryText [ngClass]="classPercentPrice$ | async">
                    -{{ productPrices.percent.value }}%
                    @if (productPrices.percent.showDisclaimer) {
                        <label>*</label>
                    }
                </label>
            }

            <!-- Text Promotions VEA PREWARM -->
            @if (!hidePriceText && discountText$ | async; as discount) {
                <ng-container pricesPromotion>
                    @if (discount.promotionInfo) {
                        <span class="text-m" (click)="openSuscriptionJoin(discount.cta)">
                            {{ discount.key | translate }}
                        </span>
                    }
                </ng-container>
            }

            @if (product) {
                <product-promotion-dates productPromotionDates [product]="product" [isPageProduct]="isPageProduct"></product-promotion-dates>
            }

            @if (productPrices?.unitPrice && isPageProduct) {
                <product-unit-price productUnitPrice [unitPrice]="productPrices.unitPrice"></product-unit-price>
            }
        </formatted-price>
    </div>
}
